import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _isEmpty from 'lodash/isEmpty';
import Dropdown from '@sitebase/ui-kit/es/Dropdown';
import { Anchor } from '@sitebase/ui-kit/es/buttons';

import ArrowDownSlim from '@wh/svg-icons/ArrowDownSlim';
import cx from 'classnames';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HeaderContext from '../../Layout/HeaderContext';
import { getAllowedAttributes } from '../../props-filters';

import './AdditionalNavItem.scss';

var preventLinkClickDefault = function preventLinkClickDefault(e) {
  return e.preventDefault();
};

// eslint-disable-next-line react/prop-types
var renderButton = function renderButton(_ref) {
  var storeTriggerRef = _ref.storeTriggerRef,
      label = _ref.label,
      active = _ref.active,
      nested = _ref.nested,
      onClick = _ref.onClick,
      icon = _ref.icon;
  return React.createElement(
    'span',
    {
      ref: storeTriggerRef,
      className: cx({
        'sb-header-additional-nav-item__button': true,
        'sb-header-additional-nav-item__button--active': active
      }),
      onClick: onClick
    },
    icon && React.createElement(
      'div',
      { className: 'sb-header-additional-nav-item__icon' },
      icon
    ),
    label,
    nested && React.createElement(ArrowDownSlim, { className: 'sb-header-additional-nav-item__arrow' })
  );
};

var AdditionalNavItem = function (_Component) {
  _inherits(AdditionalNavItem, _Component);

  function AdditionalNavItem() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, AdditionalNavItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AdditionalNavItem.__proto__ || _Object$getPrototypeOf(AdditionalNavItem)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.onTriggerClick = function (event) {
      var _this$props$onClick = _this.props.onClick,
          onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick;


      _this.toggleDropdown();
      onClick(event);
    }, _this.getTriggerRef = function () {
      return _this.triggerRef;
    }, _this.toggleDropdown = function () {
      return _this.setState({ open: !_this.state.open });
    }, _this.handleCloseRequest = function () {
      return _this.setState({ open: false });
    }, _this.storeTriggerRef = function (ref) {
      _this.triggerRef = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdditionalNavItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var open = this.state.open;

      var _props = this.props,
          label = _props.label,
          children = _props.children,
          icon = _props.icon,
          href = _props.href,
          target = _props.target,
          rel = _props.rel,
          onClick = _props.onClick,
          restProps = _objectWithoutProperties(_props, ['label', 'children', 'icon', 'href', 'target', 'rel', 'onClick']);

      var link = href ? React.createElement(
        Anchor,
        {
          outfit: 'inherit normal',
          onClick: onClick ? preventLinkClickDefault : undefined,
          target: target,
          href: href,
          rel: rel
        },
        label
      ) : null;
      return React.createElement(
        HeaderContext.Consumer,
        null,
        function (_ref3) {
          var _ref3$subNavCustom = _ref3.subNavCustom;
          _ref3$subNavCustom = _ref3$subNavCustom === undefined ? {} : _ref3$subNavCustom;
          var _ref3$subNavCustom$co = _ref3$subNavCustom.color,
              color = _ref3$subNavCustom$co === undefined ? '#fff' : _ref3$subNavCustom$co,
              _ref3$subNavCustom$ba = _ref3$subNavCustom.background,
              background = _ref3$subNavCustom$ba === undefined ? '#000c24' : _ref3$subNavCustom$ba;

          var nested = !_isEmpty(children);
          var classnames = cx({
            'sb-header-additional-nav-item': true,
            'sb-header-additional-nav-item--nested': nested
          });
          return React.createElement(
            'div',
            _extends({ className: classnames }, getAllowedAttributes(restProps)),
            renderButton({
              storeTriggerRef: _this2.storeTriggerRef,
              nested: nested,
              active: open,
              onClick: _this2.onTriggerClick,
              label: link || label,
              icon: icon,
              href: href,
              target: target
            }),
            children && React.createElement(
              Dropdown,
              {
                open: open,
                stickTo: _this2.getTriggerRef,
                onClose: _this2.handleCloseRequest,
                outfit: 'fixed bottom left'
              },
              React.createElement(
                'aside',
                {
                  className: 'sb-header-additional-nav-item__items',
                  style: { color: color, background: background },
                  onClick: _this2.handleCloseRequest
                },
                children
              )
            )
          );
        }
      );
    }
  }]);

  return AdditionalNavItem;
}(Component);

AdditionalNavItem.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node,
  onClick: PropTypes.func,
  icon: PropTypes.node,
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string
};
export default AdditionalNavItem;
//# sourceMappingURL=AdditionalNavItem.js.map